import { CALL_API } from '../../../common/middleware/api';

export const HEAD_OFFICE_ANALYTICS_REQUEST = 'HEAD_OFFICE_ANALYTICS_REQUEST';
export const HEAD_OFFICE_ANALYTICS_SUCCESS = 'HEAD_OFFICE_ANALYTICS_SUCCESS';
export const HEAD_OFFICE_ANALYTICS_FAILURE = 'HEAD_OFFICE_ANALYTICS_FAILURE';

export const loadHeadOfficeAnalyticsData = (item, options) => ({
	[CALL_API]: {
		types: [HEAD_OFFICE_ANALYTICS_REQUEST, HEAD_OFFICE_ANALYTICS_SUCCESS, HEAD_OFFICE_ANALYTICS_FAILURE],
		endpoint: `api/headOffice/analytics/${item}`,
		method: 'POST',
		request: options
	},
	item
});